var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-indicator",class:{ 'is-loading': _vm.visible }},[_c('i',{staticClass:"la la-circle-o-notch fa-spin"}),_vm._v(" "+_vm._s(_vm.$t('labels.loading-indicator'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }